// extracted by mini-css-extract-plugin
export default {"wrapper":"Carousel_wrapper__kmR7Q","item":"Carousel_item__zU5Vq"};